"use client";

import { FRONTEND_URL } from "@/constants/constants";

export const getUserCountryCode = async () => {
  const cachedUserCountryCode = localStorage.getItem("userCountryCode");

  // Already cached
  if (cachedUserCountryCode !== null) {
    return cachedUserCountryCode;
  }

  // Not cached
  let userCountryCode: string | null = null;
  try {
    const response = await fetch(`${FRONTEND_URL}/api/get-user-country-code`);

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as {
      userCountryCode: string | null;
    };

    userCountryCode = data.userCountryCode;
  } catch (error) {
    console.error("Error fetching user's country code: ", error);
    return null;
  }

  // Set cache
  if (userCountryCode !== null) {
    localStorage.setItem("userCountryCode", userCountryCode);
  }

  return userCountryCode;
};
